// extracted by css-extract-rspack-plugin
export default {"separator":"Breadcrumbs-module__separator___QB_Zt"};